import { render } from "./search-filter-referrals.vue?vue&type=template&id=a1d6d18c&scoped=true"
import script from "./search-filter-referrals.vue?vue&type=script&lang=js"
export * from "./search-filter-referrals.vue?vue&type=script&lang=js"

import "./search-filter-referrals.vue?vue&type=style&index=0&id=a1d6d18c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d6d18c"]])

export default __exports__